import React, { useEffect, useState } from "react";
import { Download, Trash2, ChevronDown, ChevronUp } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";
import { api } from "@/lib/api";

const STATUS = ["novo", "em_contato", "convertido", "perdido"];

export default function LeadsTab() {
  const [leads, setLeads] = useState([]);
  const [filter, setFilter] = useState("todos");
  const [expanded, setExpanded] = useState(null);

  const load = () => api.get("/leads").then((r) => setLeads(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const changeStatus = async (id, status) => { await api.patch(`/leads/${id}`, { status }); load(); };
  const remove = async (id) => { if (!window.confirm("Excluir lead?")) return; await api.delete(`/leads/${id}`); load(); };
  const exportCsv = async () => {
    try {
      const res = await api.get("/leads/export", { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a"); a.href = url; a.download = "leads.csv"; a.click();
      URL.revokeObjectURL(url);
    } catch { toast.error("Falha ao exportar"); }
  };

  const shown = filter === "todos" ? leads : leads.filter((l) => l.brand === filter);

  return (
    <div>
      <div className="flex justify-between items-center mb-5 flex-wrap gap-3">
        <div className="flex gap-2">
          {["todos", "stamp", "sports"].map((f) => (
            <button key={f} onClick={() => setFilter(f)} data-testid={`lead-filter-${f}`}
              className={`px-3 py-1.5 rounded-lg text-sm font-semibold ${filter === f ? "btn-primary" : "border border-[var(--border)] text-[var(--text-muted)]"}`}>
              {f === "todos" ? "Todos" : f === "stamp" ? "K8 Stamp" : "K8 Sports"}
            </button>
          ))}
        </div>
        <Button onClick={exportCsv} data-testid="export-leads" variant="outline" className="border-[var(--border)]"><Download size={16} className="mr-1" /> Exportar CSV</Button>
      </div>
      {shown.length === 0 ? (
        <div className="card-surface p-10 text-center text-[var(--text-muted)]">Nenhum orçamento ainda.</div>
      ) : (
        <div className="space-y-3">
          {shown.map((l) => (
            <div key={l.id} className="card-surface p-4" data-testid={`lead-${l.id}`}>
              <div className="flex items-center justify-between gap-3 flex-wrap">
                <div>
                  <div className="font-bold">{l.name} <span className="text-xs px-1.5 py-0.5 rounded bg-white/10">{l.brand}</span></div>
                  <div className="text-xs text-[var(--text-muted)]">{l.whatsapp} · {new Date(l.created_at).toLocaleString("pt-BR")}</div>
                </div>
                <div className="flex items-center gap-2">
                  <Select value={l.status} onValueChange={(v) => changeStatus(l.id, v)}>
                    <SelectTrigger className="w-36 bg-[var(--bg-secondary)]" data-testid={`lead-status-${l.id}`}><SelectValue /></SelectTrigger>
                    <SelectContent>{STATUS.map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}</SelectContent>
                  </Select>
                  <button onClick={() => setExpanded(expanded === l.id ? null : l.id)}>{expanded === l.id ? <ChevronUp /> : <ChevronDown />}</button>
                  <button onClick={() => remove(l.id)} className="text-red-400" data-testid={`delete-lead-${l.id}`}><Trash2 size={16} /></button>
                </div>
              </div>
              {expanded === l.id && (
                <div className="mt-4 border-t border-[var(--border)] pt-4 text-sm text-[var(--text-muted)] grid md:grid-cols-2 gap-2">
                  <div><b className="text-[var(--text-main)]">Produto:</b> {l.product_interest || "—"}</div>
                  <div><b className="text-[var(--text-main)]">Quantidade:</b> {l.quantity || "—"}</div>
                  <div><b className="text-[var(--text-main)]">Data:</b> {l.needed_date || "—"}</div>
                  <div><b className="text-[var(--text-main)]">Cidade/UF:</b> {l.city_uf || "—"}</div>
                  <div className="md:col-span-2"><b className="text-[var(--text-main)]">Observações:</b> {l.notes || "—"}</div>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
